<template>
  <AiDashboard
    :client="data._id"
    :aiEnabled="data.aiEnabled"
    :url="'/v2/ai/get-all-features'"
    :editable="false"
  />
</template>

<script>
import AiDashboard from './AiDashboard.vue';

export default {
  components: { AiDashboard },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      data: {
        _id: '',
        aiEnabled: false
      }
    };
  },
  mounted() {
  }
};
</script>